import React from 'react'
import PropTypes from 'prop-types'
import { Button as MaterialButton } from '@material-ui/core'

class Component extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <MaterialButton className={this.props.className} variant="contained" color="primary" {...this.props} onClick={() => this.props.onClick()}>
                {this.props.value}
            </MaterialButton>
        )
    }
}

Component.propTypes = {
    className: PropTypes.objectOf(PropTypes.string),
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
}

export const Button = Component
